import { render, staticRenderFns } from "./match-controller.vue?vue&type=template&id=49576ec1&scoped=true"
import script from "./match-controller.vue?vue&type=script&lang=js"
export * from "./match-controller.vue?vue&type=script&lang=js"
import style0 from "./match-controller.vue?vue&type=style&index=0&id=49576ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49576ec1",
  null
  
)

export default component.exports